module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAfElEQVR42u3aIQHAMAwAweDikgmopgmppIopmafMRFgOvIHDH5kZnQsAAAAAAAAAAAAAAJoDfHNlZePs0p73lgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB0AnCKAgAAAAAAAAAAAADQqh8WKqSKWBRfnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Mars.png
// module id = R020
// module chunks = 0 62 63